import { graphql, useStaticQuery } from "gatsby";
import React, { useState } from "react";
import { css } from "styled-components";

import MockPhone from "./MockPhone";
import withViewportWatch from "../analytics/withViewportWatch";
import ImageInContext from "../Media/ImageInContext";

const PhoneFormsGenerated = (props) => {
  const data = useStaticQuery(graphql`
    query PhoneFormsGeneratedQuery {
      previewVolPetition: file(base: { eq: "preview-docs-vol-petition.png" }) {
        childImageSharp {
          fluid(cropFocus: CENTER, maxHeight: 540, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      previewAB: file(base: { eq: "preview-docs-schedule-ab.png" }) {
        childImageSharp {
          fluid(cropFocus: CENTER, maxHeight: 540, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      previewEF: file(base: { eq: "preview-docs-schedule-ef.png" }) {
        childImageSharp {
          fluid(cropFocus: CENTER, maxHeight: 540, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      previewCreditorMatrix: file(base: { eq: "preview-docs-creditor-matrix.png" }) {
        childImageSharp {
          fluid(cropFocus: CENTER, maxHeight: 540, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      previewLocalForms: file(base: { eq: "preview-docs-local-forms.png" }) {
        childImageSharp {
          fluid(cropFocus: CENTER, maxHeight: 540, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);
  const [animating, setAnimating] = useState(false);
  const [show101] = useState(true);
  const [showAB, setShowAB] = useState(false);
  const [showEF, setShowEF] = useState(false);
  const [showCM, setShowCM] = useState(false);
  const [showLF, setShowLF] = useState(false);
  // Cascading sliding through pages
  function handleAnimation() {
    const PAGE_TURN_TIMING = 4000;
    setAnimating(true);
    setTimeout(() => {
      setShowAB(true);
      setTimeout(() => {
        setShowEF(true);
        setTimeout(() => {
          setShowCM(true);
          setTimeout(() => {
            setShowLF(true);
            setTimeout(() => {
              setAnimating(false);
            }, PAGE_TURN_TIMING);
          }, PAGE_TURN_TIMING);
        }, PAGE_TURN_TIMING);
      }, PAGE_TURN_TIMING);
    }, 3000);
  }
  // Only when the visitor gets the phone within their screen should start the animation
  if (!animating && props.isInViewport) handleAnimation();

  return (
    <MockPhone cssOverrides={cssOverrides}>
      <div className={`preview-doc-panel ${showAB ? "unfocus-doc" : ""}`}>
        <ImageInContext alt="Voluntary Petition" fluid={data.previewVolPetition.childImageSharp.fluid} />
        <div className="generate-button">Generate Voluntary Petition</div>
      </div>
      {showAB && !showCM && (
        <div className={`preview-doc-panel ${showEF ? "unfocus-doc" : ""}`}>
          <ImageInContext alt="Schedule a/b" fluid={data.previewAB.childImageSharp.fluid} />
          <div className="generate-button">Generate Schedule A/B</div>
        </div>
      )}
      {showEF && !showLF && (
        <div className={`preview-doc-panel ${showCM ? "unfocus-doc" : ""}`}>
          <ImageInContext alt="Schedule E/F" fluid={data.previewEF.childImageSharp.fluid} />
          <div className="generate-button">Generate Schedule E/F</div>
        </div>
      )}
      {showCM && animating && (
        <div className={`preview-doc-panel ${showLF ? "unfocus-doc" : ""}`}>
          <ImageInContext alt="Creditors Matrix" fluid={data.previewCreditorMatrix.childImageSharp.fluid} />
          <div className="generate-button">Generate Creditor Matrix</div>
        </div>
      )}
      {showLF && (
        <div className={`preview-doc-panel`}>
          <ImageInContext alt="Local Forms" fluid={data.previewLocalForms.childImageSharp.fluid} />
          <div className="generate-button">Generate Local Forms</div>
        </div>
      )}
    </MockPhone>
  );
};

const cssOverrides = css`
  transform: rotate(-4deg);
  @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
    transform: rotate(0);
  }
  div.phone__checklist {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: ${(props) => props.theme.colors.gray[400]};
    padding: 0.5em;
  }
  div.preview-doc-panel {
    position: absolute;
    width: calc(100% - 1em); // 100% - 0.5x2 horizontal padding
    margin: 0 auto;
    animation: slide-in-document 500ms;
    animation-fill-mode: forwards;
    @keyframes slide-in-document {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(0%);
      }
    }
    &.unfocus-doc {
      animation: unfocus-document 750ms;
      animation-fill-mode: forwards;
      @keyframes unfocus-document {
        0% {
          opacity: 1;
        }
        50% {
          opacity: 0;
        }
        95% {
          transform: translateX(-100%);
          opacity: 0;
        }
        100% {
          transform: translateX(-100%);
          opacity: 0;
          display: none;
        }
      }
    }
    & > div:not(.generate-button) {
      width: 100%;
      border-radius: 4px;
      overflow: hidden;
    }
    .generate-button {
      border-radius: 8px;
      margin: 1em 0 0;
      padding: 0.5em 1em;
      text-align: center;
      background: ${(props) => props.theme.colors.brand[500]};
      border-bottom: 3px solid ${(props) => props.theme.colors.brand[300]};
      color: white;
      font-size: 14px;
    }
  }
`;

export default withViewportWatch(PhoneFormsGenerated);
